import { Route, BrowserRouter, Routes } from "react-router-dom";
import Main from "./Pages/Main/Main";
import Privacy from "./Pages/Privacy/Privacy";
import Error from "./Pages/Error/Error";
import { Toaster } from "react-hot-toast";
import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Toaster />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
